import { useEffect, useState } from "react";
import "../css/mobilelogin.css"
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const parseJwt = (token) => {
    try {
        const base64 = token.split(".")[1];
        const norm = base64.replace(/-/g, "+").replace(/_/g, "/")
            .padEnd(Math.ceil(base64.length / 4) * 4, "=");
        return JSON.parse(atob(norm));
    } catch {
        return null;
    }
};
const isTokenValid = (token) => {
    const p = parseJwt(token);
    return !!p?.exp && p.exp * 1000 > Date.now();
};

export default function MobileLogin() {
    const navigate = useNavigate();

    const [loginData, setLoginData] = useState({
        username: "",
        password: ""
    })
    const [rememberId, setRememberId] = useState(false);
    const [autoLogin, setAutoLogin] = useState(false);

    // 최초 로드: 저장된 아이디/설정 복원 + 자동로그인 시도
    useEffect(() => {
        document.body.classList.add("home-bg");
        const savedId = localStorage.getItem("savedUsername");
        const rId = localStorage.getItem("rememberId") === "true";
        const aLogin = localStorage.getItem("autoLogin") === "true";
        const token = localStorage.getItem("accessToken");
        if (rId && savedId) {
            setLoginData(v => ({ ...v, username: savedId }));
            setRememberId(true);
        }

        if (aLogin) setAutoLogin(true);

        // 자동 로그인: 토큰이 있고 유효하면 바로 진입
        if (aLogin && token && isTokenValid(token)) {
            navigate("/home");
        }
        return () => document.body.classList.remove("home-bg");
    }, [navigate]);

    const handlerInputChange = (e) => {
        const { name, value } = e.target;

        setLoginData({
            ...loginData,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/login`, loginData, {
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
            })

            .then((response) => {
                // 👉 Axios는 객체 헤더라 get() 없음. get을 꼭 쓰고 싶으면 Headers로 감싸기
                const authHeader = new Headers(response.headers).get("Authorization")
                    || response.headers["authorization"];
                const token = response.data?.token
                    ?? authHeader?.replace(/^Bearer\s+/i, "");

                if (!token) {
                    alert("로그인 응답에 토큰이 없습니다.");
                    return;
                }

                const bearer = authHeader ?? `Bearer ${token}`;
                localStorage.setItem("accessToken", bearer);

                // ② (선택) Axios 전역 헤더에도 세팅
                axios.defaults.headers.common.Authorization = bearer;

                // 아이디 저장
                if (rememberId) {
                    localStorage.setItem("savedUsername", loginData.username);
                    localStorage.setItem("rememberId", "true");
                } else {
                    localStorage.removeItem("savedUsername");
                    localStorage.setItem("rememberId", "false");
                }

                // 자동 로그인 플래그
                localStorage.setItem("autoLogin", autoLogin ? "true" : "false");

                navigate("/home");
            })

            .catch((err) => {
                alert("아이디 비밀번호를 확인해 주세요.");
            });
    };

    useEffect(() => {
        document.body.classList.add("home-bg");
        return () => document.body.classList.remove("home-bg"); // 페이지 벗어나면 제거
    }, []);

    return (
        <>
            <nav className="Nav_Login">
                <div>
                    <img src="/images/GuardianFieldmaster_white.png" width="300px" height="100px"></img>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="Login">
                        <div>
                            <input name="username" value={loginData.username} onChange={handlerInputChange} type="text" placeholder="아이디를 입력해주세요"></input>
                        </div>
                        <div>
                            <input name="password" value={loginData.password} onChange={handlerInputChange} type="password" placeholder="비밀번호를 입력해주세요"></input>
                        </div>
                        <div>
                            <div>
                                <input type="checkbox" checked={rememberId}
                                    onChange={(e) => setRememberId(e.target.checked)} ></input>
                                <p>아이디 저장</p>
                            </div>
                            <div>
                                <input type="checkbox" checked={autoLogin}
                                    onChange={(e) => setAutoLogin(e.target.checked)}></input>
                                <p>자동 로그인</p>
                            </div>
                        </div>
                        <div>
                            <button type="submit">로그인</button>
                        </div>

                        <Link to="/signup"><div>
                            <button type="button">회원가입</button>
                        </div>
                        </Link>
                        <div>
                            <Link to="/findid"><div>아이디 찾기</div></Link>
                            <Link to="findpw"><div>비밀번호 찾기</div></Link>
                        </div>
                    </div>
                </form>

            </nav>
        </>
    )
}